import { useState, useEffect } from "react";
import { Row, Col, Button, Form, Alert, Modal, ProgressBar, Card } from "react-bootstrap";

import _ from "lodash";
import axios from "axios";
import Utils from "../../common/Utils";
import AddJobs from "./AddJobs";

const RoleForm = (props) => {
  const [data, setData] = useState(props.mode === 2 ? props.data : {});
  const [jobs, setJobs] = useState([]);
  const [showAdd, setShowAdd] = useState(false);
  const [adding, setAdding] = useState(false);
  const [loading, setLoading] = useState(true);
  const [rkey, setRKey] = useState("");

  const fetchRoleJobs = () => {
    setLoading(true);
    axios
      .get(Utils.apiUrl(`users/fetchrolejobs/${data.id}`), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setJobs(_.get(res, "data.jobs", []));
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(true);
        console.log(err);
      });
  };

  useEffect(fetchRoleJobs, []);

  const saveRole = (e) => {
    const frm = e.currentTarget;
    e.preventDefault();

    setAdding(true);

    let pvals = {
      name: frm.name.value,
    };

    if (props.mode === 2) {
      pvals = {
        ...pvals,
        id: data.id,
      };
    }

    axios
      .post(Utils.apiUrl("users/saverole"), Utils.postVars(pvals), Utils.apiHeaders())
      .then((res) => {
        setAdding(false);
        props.afterSave(res.data);
      })
      .catch((err) => console.log(err));
  };

  const removeJob = (e, jid) => {
    if (window.confirm(`You are going to delete this job from role, continue?`)) {
      setLoading(true);
      axios
        .delete(Utils.apiUrl(`users/deleterolejob/${data.id}?jid=${jid}`), Utils.apiHeaders())
        .then((res) => {
          setLoading(false);
          if (res.data.success) {
            //setMessage({ type: "success", message: res.data.message });
            setJobs(_.filter(jobs, (j) => j.id !== jid));
          }
        })
        .catch((err) => {
          window.alert(_.isObject(err.message) ? Object.values(err.message).join(",") : err.message);
          setLoading(false);
        });
    } else {
      e.preventDefault();
    }
  };

  return (
    <>
      <Card className="my-3">
        <Card.Body>
          {adding && (
            <Alert variant="info" className="p-3">
              <p className="loading-msg">saving data..</p>
              <ProgressBar variant="info" animated now={100} />
            </Alert>
          )}
          {!adding && (
            <>
              <Form className="needs-validation" novalidate onSubmit={saveRole}>
                <div className="row">
                  <div className="col-sm-6 mb-3">
                    <input
                      type="text"
                      required
                      name="name"
                      maxlength="255"
                      className="form-control"
                      placeholder="Role"
                      defaultValue={_.get(data, "name", "")}
                    />
                    <div className="alert alert-warning p-1">Role name example (DC Andover - Dental Nurse)</div>
                  </div>
                  <div className="col-sm-6 mb-3">
                    <Button type="submit" variant="primary" className="py-1 px-4">
                      Save Role
                    </Button>
                  </div>
                </div>
              </Form>
              {props.mode === 2 && (
                <>
                  <hr />
                  {!showAdd && loading && (
                    <Alert variant="info" className="p-3">
                      <p className="loading-msg">Fetching role jobs..</p>
                      <ProgressBar variant="info" animated now={100} />
                    </Alert>
                  )}
                  {!loading && (
                    <>
                      <Row>
                        <Col>
                          Role Jobs:{" "}
                          <Button variant="warning" onClick={() => setShowAdd(true)}>
                            Add Jobs
                          </Button>
                        </Col>
                        <Col>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Filter by Job title"
                            onKeyUp={(e) => setRKey(e.currentTarget.value)}
                          />
                        </Col>
                      </Row>
                      <div className="d-flex flex-row flex-wrap gx-0 gy-2 p-2 my-1">
                        {_.filter(jobs, (j) => j.name.indexOf(rkey) > -1).map((j) => (
                          <Alert variant="info" className="m-1 p-1">
                            {j.name}
                            <Button
                              size="xs"
                              variant="dark"
                              className="mx-1"
                              title="Click to remove Job from Role"
                              onClick={(e) => removeJob(e, j.id)}
                            >
                              x
                            </Button>
                          </Alert>
                        ))}
                      </div>
                    </>
                  )}
                  {showAdd && (
                    <AddJobs
                      role={data}
                      afterSave={() => {
                        //setShowAdd(false);
                        fetchRoleJobs();
                      }}
                      onHide={() => setShowAdd(false)}
                    />
                  )}
                </>
              )}
            </>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default RoleForm;
